var _effectorFileName = "/src/page-content/pair-lessons/components/main-pair-lessons/main-pair-lessons.tsx";
import Image from 'next/image';
import { useTranslation } from 'next-i18next';
import { GradientBg } from '@/shared/components/animation/gradient-background';
import { Article } from '@/shared/components/article';
import { ContactModal } from '@/shared/components/contact-modal';
import { TextGradient } from '@/shared/components/text-gradient';
import { Button } from '@/shared/components/ui/button';
export const MainPairLessons = () => {
  const {
    t
  } = useTranslation('pair-lessons-main');
  return <Article tag="main">
      <div className="grid grid-cols-1 items-center gap-x-5 sm:grid-cols-[1fr_minmax(200px,_40%)] sm:gap-x-10">
        <div className="mx-auto sm:mx-0">
          <div className="mb-10 sm:mb-5 sm:max-w-[620px]">
            <TextGradient text={t('title')} tag="h1" className="mb-6 text-center text-5xl sm:mb-4 sm:max-w-lg sm:text-left" />

            <p className="mx-auto text-sm xss:max-w-sm xss:pl-6 sm:mx-0 sm:max-w-xl sm:pl-0 sm:text-left sm:text-base" dangerouslySetInnerHTML={{
            __html: t('description')
          }} />
          </div>

          <div className="flex justify-center sm:block">
            <ContactModal entryPoint="PAIR_PAGE">
              <Button variant="cta" className="px-6" aria-label={t('ctaAria')}>
                {t('cta')}
              </Button>
            </ContactModal>
          </div>
        </div>

        <div className="relative hidden items-center justify-end sm:flex 2xl:justify-center">
          <div className="min-h-[500px] max-w-full">
            <Image className="mx-auto hidden h-full w-full object-contain sm:inline-flex" src="/images/pair-lessons/main.webp" alt={t('imageAlt')} loading="lazy" fill />
          </div>

          <GradientBg className="z-0 hidden sm:block" type="circle" origin="center" size={300} />
        </div>
      </div>
    </Article>;
};